import { Registry } from '@bem-react/di';
import { cnAttach } from '../Attach.const';
import { Holder } from '../Holder/Attach-Holder';
import { Control } from '../Control/Attach-Control';
export var attachRegistry = new Registry({ id: cnAttach() });
attachRegistry
    .set('Holder', Holder)
    .set('Control', Control)
    .set('Button', function () {
    // TODO: Использовать error api из новой версии react.
    throw new Error("\u0414\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \"Attach\" \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \"Button\" \u0432 \u0440\u0435\u0435\u0441\u0442\u0440 \"" + cnAttach() + "\".");
});
